import api from '../config/api';

export const getArticles = page => api.get('/articles', { starred_at: false, page }); // eslint-disable-line camelcase
export const getArticle = id => api.get(`/articles/${id}`);
export const getArticleInterestContent = id => api.get(`/articles/${id}/may_interest`);
export const getStarredArticle = () => api.get('/contents/starred?type=articles');
